/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import BookWithBookmarkIcon from '@atlaskit/icon/core/book-with-bookmark';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { createKbMessages } from './messages';

const styles = cssMap({
	header: {
		paddingTop: token('space.200'),
		paddingRight: token('space.250'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.250'),
		borderBottom: `${token('border.width')} solid ${token('color.border')}`,
	},
});

export const CreateKBCardHeader = (): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Inline
			alignBlock="center"
			space="space.075"
			testId="create-kb-card-header"
			xcss={styles.header}
		>
			<BookWithBookmarkIcon color={token('color.icon.warning')} label="" />
			<Text size="large" weight="bold" color="color.text">
				{formatMessage(createKbMessages.titleMessage)}
			</Text>
		</Inline>
	);
};
